module.exports = __webpack_public_path__ + "static/media/loader.921ec9e6.svg";